var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "filter-app" }, [
    _c("section", { staticClass: "section-wrapper filters" }, [
      _c(
        "div",
        { staticClass: "content-wrapper" },
        [
          _c("FiltersSection", {
            attrs: {
              APICall: _vm.APICall,
              applyFiltersText: _vm.applyFiltersText,
              applyFiltersToAPICall: _vm.applyFiltersToAPICall,
              clearAllFilters: _vm.clearAllFilters,
              clearFiltersText: _vm.clearFiltersText,
              culturalExperience: _vm.culturalExperience,
              deleteSubRegions: _vm.deleteSubRegions,
              disableSubRegionDropdown: _vm.disableSubRegionDropdown,
              enableSupplierFocusedSearch: _vm.enableSupplierFocusedSearch,
              genders: _vm.genders,
              locations: _vm.locations,
              languages: _vm.languages,
              optionalExpanded: _vm.optionalExpanded,
              removeFilterFromButton: _vm.removeFilterFromButton,
              selectedCulturalExperience: _vm.selectedCulturalExperience,
              selectedGenders: _vm.selectedGenders,
              selectedLanguages: _vm.selectedLanguages,
              selectedRegion: _vm.selectedRegion,
              selectedSubRegions: _vm.selectedSubRegions,
              selectedTherapistExperience: _vm.selectedTherapistExperience,
              subRegionsForRegion: _vm.subRegionsForRegion,
              therapistExperience: _vm.therapistExperience,
              updateFilterFromButton: _vm.updateFilterFromButton,
              updateRegion: _vm.updateRegion,
              updateShowOptions: _vm.updateShowOptions,
              updateSubRegions: _vm.updateSubRegions,
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.enableSupplierFocusedSearch
      ? _c("div", [
          _c("div", { staticClass: "filters-results" }, [
            _c("section", { staticClass: "results-section-wrapper" }, [
              _c(
                "div",
                { staticClass: "content-wrapper results" },
                [
                  _c("ResultsSection", {
                    attrs: {
                      APICall: _vm.APICall,
                      loading: _vm.loading,
                      isTab2: true,
                      message: _vm.message,
                      messageType: _vm.messageType,
                      noResultsText: _vm.noResultsText,
                      providerCount: _vm.filterSearchResponse.providerCount,
                      providers: _vm.filterSearchResponse,
                      resultsCurrentPage: _vm.filterSearchResponse.page,
                      resultsExplainerText: _vm.resultsExplainerText,
                      resultsTotalPages: _vm.filterSearchResponse.pageCount,
                      showNoResultsText: _vm.showNoResultsText,
                      showResultsCountText: _vm.showResultsCountText,
                      supplierCount: _vm.filterSearchResponse.supplierCount,
                      suppliers: _vm.filterSearchResponse.suppliers,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ])
      : _c(
          "div",
          [
            _c(
              "Tabs",
              {
                attrs: {
                  enableSupplierFocusedSearch: _vm.enableSupplierFocusedSearch,
                },
              },
              [
                _c(
                  "Tab",
                  {
                    attrs: {
                      enableSupplierFocusedSearch:
                        _vm.enableSupplierFocusedSearch,
                      name: _vm.resultsTab1Text,
                      isTab2: false,
                      selected: "true",
                    },
                  },
                  [
                    _c("div", { staticClass: "tab" }, [
                      _c("div", { staticClass: "filters-results" }, [
                        _c(
                          "section",
                          { staticClass: "results-section-wrapper" },
                          [
                            _c(
                              "div",
                              { staticClass: "content-wrapper results" },
                              [
                                _c("ResultsSection", {
                                  attrs: {
                                    APICall: _vm.APICall,
                                    isTab2: false,
                                    loading: _vm.loading,
                                    message: _vm.message,
                                    messageType: _vm.messageType,
                                    noResultsText: _vm.noResultsText,
                                    pagination: _vm.pagination,
                                    providerCount:
                                      _vm.filterSearchResponse.providerCount,
                                    providers: _vm.filterSearchResponse,
                                    resultsCurrentPage:
                                      _vm.filterSearchResponse.page,
                                    resultsExplainerText:
                                      _vm.resultsExplainerText,
                                    resultsTotalPages:
                                      _vm.filterSearchResponse.pageCount,
                                    showNoResultsText: _vm.showNoResultsText,
                                    showResultsCountText:
                                      _vm.showResultsCountText,
                                    suppliers:
                                      _vm.filterSearchResponse.suppliers,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "Tab",
                  {
                    attrs: {
                      enableSupplierFocusedSearch:
                        _vm.enableSupplierFocusedSearch,
                      name: _vm.resultsTab2Text,
                      isTab2: true,
                    },
                  },
                  [
                    _c("div", { staticClass: "tab" }, [
                      _c("div", { staticClass: "filters-results" }, [
                        _c(
                          "section",
                          { staticClass: "results-section-wrapper" },
                          [
                            _c(
                              "div",
                              { staticClass: "content-wrapper results" },
                              [
                                _c("ResultsSection", {
                                  attrs: {
                                    APICall: _vm.APICall,
                                    loading: _vm.loading,
                                    isTab2: true,
                                    message: _vm.message,
                                    messageType: _vm.messageType,
                                    noResultsText: _vm.noResultsText,
                                    providerCount:
                                      _vm.filterSearchResponse.providerCount,
                                    providers: _vm.filterSearchResponse,
                                    resultsCurrentPage:
                                      _vm.filterSearchResponse.page,
                                    resultsExplainerText:
                                      _vm.resultsExplainerText,
                                    resultsTotalPages:
                                      _vm.filterSearchResponse.pageCount,
                                    showNoResultsText: _vm.showNoResultsText,
                                    showResultsCountText:
                                      _vm.showResultsCountText,
                                    supplierCount:
                                      _vm.filterSearchResponse.supplierCount,
                                    suppliers:
                                      _vm.filterSearchResponse.suppliers,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }